export const searchConstants = {
  SEARCH_SUBMIT_START: "SEARCH_SUBMIT_START",
  SEARCH_SUBMIT_SUCCESS: "SEARCH_SUBMIT_SUCCESS",
  SEARCH_SUBMIT_FAILURE: "SEARCH_SUBMIT_FAILURE",

  SEARCH_SHOW_START: "SEARCH_SHOW_START",
  SEARCH_SHOW_SUCCESS: "SEARCH_SHOW_SUCCESS",
  SEARCH_SHOW_FAILURE: "SEARCH_SHOW_FAILURE",

  SEARCH_SUPPORT_CALL:"SEARCH_SUPPORT_CALL"
};
